import axios from 'axios';
import type { PriceMap } from '../../../api/types';

export type { PriceMap };

const getPriceMap = async () => {
  const { data } = await axios.get<PriceMap>(`/org/price_map`);
  return data;
};

export default getPriceMap;
